import { xhrPromise } from "shared/lib/xhr_promise"

export function put(url, data) {
  return xhrPromise(url, { method: "put", data })
}

export function post(url, data) {
  return xhrPromise(url, { method: "post", data })
}

export function patch(url, data) {
  return xhrPromise(url, { method: "patch", data })
}

export function get(url, params = {}) {
  return xhrPromise(url, { method: "get", data: params })
}

export function del(url) {
  return xhrPromise(url, { method: "delete" })
}

export function putFile(url, file) {
  return xhrPromise(url, {
    method: "put",
    data: file,
    contentType: file.type,
    processData: false,
  })
}
